export const formGql = `... on landingPageContent_form_BlockType {
  typeHandle
  form {
    id
  }
}`;
